'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, startTransition, useContext, useState } from 'react';
import type { CompareBarContextType, CompareBarProviderProps, ComparisonCreditCardOffer } from '../types';
import { sortOffersAlphabetically } from './utils';
const CompareBarContext = createContext<CompareBarContextType | null>(null);
export function CompareBarProvider(t0) {
  const $ = _c(25);
  const {
    allOffers,
    children
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [idsToCompare, setIdsToCompare] = useState(t1);
  const [remainingOffers, setRemainingOffers] = useState(allOffers);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [offersToCompare, setOffersToCompare] = useState(t2);
  let t3;
  if ($[2] !== allOffers) {
    t3 = updatedIds => {
      const selectedOffers = updatedIds.map(id => allOffers.find(offer => offer.id === id));
      const unselectedOffers = allOffers.filter(offer_0 => !updatedIds.includes(offer_0.id));
      const sortedUnselectedOffers = sortOffersAlphabetically(unselectedOffers);
      setOffersToCompare(selectedOffers);
      setRemainingOffers(sortedUnselectedOffers);
    };
    $[2] = allOffers;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const updateRemainingAndSelectedOffers = t3;
  let t4;
  if ($[4] !== idsToCompare || $[5] !== updateRemainingAndSelectedOffers) {
    t4 = id_0 => {
      const updatedIds_0 = idsToCompare.includes(id_0) || idsToCompare.length === 3 ? idsToCompare : [...idsToCompare, id_0];
      startTransition(() => {
        setIdsToCompare(updatedIds_0);
        updateRemainingAndSelectedOffers(updatedIds_0);
      });
    };
    $[4] = idsToCompare;
    $[5] = updateRemainingAndSelectedOffers;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const addIdToCompare = t4;
  let t5;
  if ($[7] !== idsToCompare || $[8] !== updateRemainingAndSelectedOffers) {
    t5 = id_1 => {
      const updatedIds_1 = idsToCompare.filter(offerId => offerId !== id_1);
      startTransition(() => {
        setIdsToCompare(updatedIds_1);
        updateRemainingAndSelectedOffers(updatedIds_1);
      });
    };
    $[7] = idsToCompare;
    $[8] = updateRemainingAndSelectedOffers;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const removeIdToCompare = t5;
  let t6;
  if ($[10] !== updateRemainingAndSelectedOffers) {
    t6 = () => {
      startTransition(() => {
        setIdsToCompare([]);
        updateRemainingAndSelectedOffers([]);
      });
    };
    $[10] = updateRemainingAndSelectedOffers;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const resetAllIdsToCompare = t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      startTransition(() => setIsModalOpen(true));
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const openModal = t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      startTransition(() => setIsModalOpen(false));
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const closeModal = t8;
  let t9;
  if ($[14] !== addIdToCompare || $[15] !== idsToCompare || $[16] !== isModalOpen || $[17] !== offersToCompare || $[18] !== remainingOffers || $[19] !== removeIdToCompare || $[20] !== resetAllIdsToCompare) {
    t9 = {
      idsToCompare,
      addIdToCompare,
      removeIdToCompare,
      resetAllIdsToCompare,
      offersToCompare,
      remainingOffers,
      isModalOpen,
      closeModal,
      openModal
    };
    $[14] = addIdToCompare;
    $[15] = idsToCompare;
    $[16] = isModalOpen;
    $[17] = offersToCompare;
    $[18] = remainingOffers;
    $[19] = removeIdToCompare;
    $[20] = resetAllIdsToCompare;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const value = t9;
  let t10;
  if ($[22] !== children || $[23] !== value) {
    t10 = <CompareBarContext.Provider value={value}>{children}</CompareBarContext.Provider>;
    $[22] = children;
    $[23] = value;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}
export function useCompareBar() {
  const context = useContext(CompareBarContext);
  if (!context) {
    throw new Error("useCompareBar must be used within a CompareBarProvider");
  }
  return context;
}